import React, { ReactNode, ComponentProps } from 'react'
import { styled } from 'dripsy'
import {
  Pressable as NativePressable,
  PressableStateCallbackType,
  ViewStyle,
} from 'react-native'

// react-native-web/overrides.ts
declare module 'react-native' {
  interface PressableStateCallbackType {
    hovered?: boolean
    focused?: boolean
    interacted?: boolean
  }
  interface ViewStyle {
    transitionProperty?: string
    transitionDuration?: string
    transitionDelay?: string
  }
  interface TextProps {
    accessibilityComponentType?: never
    accessibilityTraits?: never
  }
  interface PressableProps {
    onHoverIn?: (e: MouseEvent) => void
    onHoverOut?: (e: MouseEvent) => void
  }
}

type CallbackWithHovered = PressableStateCallbackType
const StyledPressable = styled(NativePressable)({})

type Props = {
  style?: ((prop: CallbackWithHovered) => ViewStyle) | ViewStyle
  children?: ReactNode | ((prop: CallbackWithHovered) => ReactNode)
} & Omit<ComponentProps<typeof StyledPressable>, 'children' | 'style'>

const Press = React.forwardRef(function Pressable(
  { sx = {}, disabled, hitSlop = 10, children, ...props }: Props,
  ref: ComponentProps<typeof NativePressable>['ref']
) {
  return (
    <StyledPressable
      {...props}
      ref={ref as any}
      disabled={disabled}
      hitSlop={hitSlop}
      sx={{
        cursor:
          props.onPress || props.accessibilityRole === 'link' || !disabled
            ? 'pointer'
            : 'default',
        ...sx,
      }}
    >
      {typeof children === 'function'
        ? (interactions) => {
            const { hovered, pressed } = interactions
            return children({
              ...interactions,
              interacted: hovered || pressed,
            })
          }
        : children}
    </StyledPressable>
  )
})

export default Press
